import React, {Component} from 'react';
import TableHolderCustom from '../visualization/table-holder-custom';
import Spinner from '../generic/spinner';
import Utils from "../../Utils/Utility";

const columns = {
    'itemName': {type: 'string', label: 'Item Name'},
    'groupName': {type: 'string', label: 'Group'},
    'itemPrice': {type: 'number', label: 'Price', prefix: '$'},
    'live': {type: 'string', label: 'Status'},
    'itemDetail': {type: 'string', label: 'Edit'}
};

export default class AllItems extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            ordersData      : [],
            filteredOrdersData : [],
            isLoaded       : false,
            showOrderModal : false,
            showExportModal: false,
            order          : [],
            maxToDate      : '',
            isPrevBtnActive: 'disabled',
            isNextBtnActive: 'disabled',
            skip           : 0,
            pagination     : false,
            totalOrderCount: 0,
            stripeUserId   : null,
            showAllItemView: false,
            groupHierarchy : null,
            q: ''
        };

        this._bind(
            'loadAllItems',
            'updateItem',
            'deleteItem',
            'duplicateItem',
            'onChange',
            'filterList'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {
        // when load the main class get all the data and reload
        this.loadAllItems();
    }


    componentWillMount() {

        this.setState({
            groupHierarchy: this.props.groupHierarchy
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null) {
            this.setState({
                    groupHierarchy: nextProps.groupHierarchy,
                    ordersData:[],
                    totalOrderCount : 0,
                },
                () => {
                    this.loadAllItems();
                });
        }
    }

    loadAllItems() {
        let self = this;
        let groupHierarchy = this.state.groupHierarchy;
        if (groupHierarchy != null) {

            // we will show item based on the selected group
            // Now we are showing default 1st group
            groupHierarchy.map((groupedObj) => {

                // let selectedGroupObj = this.state.groupHierarchy[0];
                let selectedGroupObj = groupedObj;

                if (selectedGroupObj) {

                    // console.log(JSON.stringify(selectedGroupObj));

                    const groupName = selectedGroupObj.groupDetail.groupName;
                    const pGroupId = selectedGroupObj.groupDetail.objectId;


                    if (selectedGroupObj.groupType === 'MENU') {
                        // if menu type is MENU
                        groupedObj.subGroups.map((subGroupObj) => {
                            let sortedItemDetails = subGroupObj.sortedItemDetails;
                            self.filterItemWithGroup(sortedItemDetails);

                        });

                    }
                    else{
                        // if menu type is SIMPLE
                        let sortedItemDetails = selectedGroupObj.sortedItemDetails;
                        self.filterItemWithGroup(sortedItemDetails);

                    }

                }


            });

            self.setState({
                isLoaded: true,
                totalOrderCount: groupHierarchy.length,
                showAllItemView : true
            }, () => {
                // self.setPrevAndNextBtnClass();

            });


        }
    }

    filterItemWithGroup(sortedItemDetails){

        // if menu type is SIMPLE
        let self = this;
        sortedItemDetails.forEach(result => {

            /* Response Data*/
            let newTable = {};
            Object.keys(columns).forEach(col => {
                if (col == "itemName") {
                    newTable[col] = result.itemName;
                } else if (col == "groupName") {
                    let groupName = result["groupDetailPointer"].groupName;
                    newTable[col] = groupName;
                } else if (col == "live") {
                    let status = result["live"] == true ? "Online" : "Offline";
                    newTable[col] = status;
                } else if (col == "itemPrice") {
                    let itemPrice = Utils.number2digit(result.itemPrice);
                    newTable[col] = itemPrice;
                } else if (col == "itemDetail") {
                    newTable[col] = result;
                } else {
                    // newTable[col] = result[col];
                }
            });

            self.state.ordersData.push(newTable);
        });

        self.filterList();

    }

    updateItem(itemDetail){
        this.props.callBackUpdateItem(itemDetail);

    }

    duplicateItem(itemDetail){
        this.props.callBackDuplicateItem(itemDetail);

    }

    deleteItem(itemDetail){
        this.props.callBackDeleteItem(itemDetail);

    }

    onChange(event) {
        const q = event.target.value.toLowerCase();

       // console.log(JSON.stringify(q));

        this.setState({ q }, () => this.filterList());
    }

    filterList() {
        let ordersData = this.state.ordersData;
        let q = this.state.q;

        ordersData = ordersData.filter(function(order) {
            return order.itemName.toLowerCase().indexOf(q) != -1; // returns true or false
        });

       // console.log(JSON.stringify(ordersData));

        this.setState({ filteredOrdersData: ordersData });
    }

    render() {

        {/*<div>*/}
            {/*<button type="button"  className="btn btn-success btn-sm" placeholder={"Update Item"} onClick={_ => this.updateItem(rowVal.itemDetail)}><i className="fa fa-edit" aria-hidden="true"></i></button>*/}
            {/*<button type="button" className="btn btn-danger btn-sm btn-margin-l10" placeholder={"Delete Item"} onClick={_ => this.deleteItem(rowVal.itemDetail)}><i className="fa fa-remove" aria-hidden="true"></i></button>*/}
            {/*<button type="button"  className="btn btn-default btn-sm btn-margin-l10" placeholder={"Duplicate Item"} onClick={_ => this.duplicateItem(rowVal.itemDetail)}><i className="fa fa-edit" aria-hidden="true"></i></button>*/}
        {/*</div>*/}

        // set custom button in the table column
        columns["itemDetail"] = {
            ...columns.itemDetail,
            Cell: rowVal => (
                    <div className="dropdown">
                        <button className="dropbtn"><i className="fa fa-ellipsis-h fa-lg" aria-hidden="true"></i></button>
                        <div className="dropdown-content">
                            <a href="JavaScript:void(0);" onClick={_ => this.updateItem(rowVal.itemDetail)}>Update</a>
                            <a href="JavaScript:void(0);" onClick={_ => this.duplicateItem(rowVal.itemDetail)}>Duplicate</a>
                            <a href="JavaScript:void(0);" onClick={_ => this.deleteItem(rowVal.itemDetail)}>Delete</a>
                        </div>
                    </div>
            )
        };

        return (
            <div className="menu-pg">
                {!this.state.isLoaded ? <Spinner/> : null}

                {
                    this.state.showAllItemView ? (
                        <div>
                            <div className = "">
                                <div className="">
                                    <div className="col-sm-12">
                                        <button className={"btn btn-primary"} onClick={this.props.callBackAddItem} style={{float:"right"}}><i className="fa fa-plus" aria-hidden="true"></i> Add Item</button>
                                        <h3 id="translations" className="page-header">All Items</h3>
                                     </div>


                                </div>
                            </div>
                            <div className="col-md-12">

                                <div className="form-group has-search">
                                    <input
                                        type="text"
                                        className="search-input"
                                        placeholder="Search Item"
                                        value={this.state.q}
                                        onChange={this.onChange}
                                    />
                                </div>

                                {
                                    this.state.totalOrderCount > 0 ?
                                        <TableHolderCustom
                                            columns={columns}
                                            tableData={this.state.filteredOrdersData}
                                            // isPrevBtnActive={this.state.isPrevBtnActive}
                                            // isNextBtnActive={this.state.isNextBtnActive}
                                            // btnPrevClick={this.btnPrevClick}
                                            // btnNextClick={this.btnNextClick}
                                            countDefault={this.state.skip}
                                            // pagination={this.state.pagination}
                                            customClass={"all-item"}
                                        />
                                        :
                                        <div className="col-md-12 text-center">
                                            <h4 className="h-small">No record found
                                            </h4>
                                        </div>
                                }
                            </div>
                        </div>
                    ) : null
                }

            </div>
        );
    }

}





// WEBPACK FOOTER //
// src/components/online-menu/all-items.js